import QuoteHelper from "../../../../utils/QuoteHelper";
import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const MileageInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}} wrap={false}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Mileage Information</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text>Miles Per Year</Text>
                    <Text>{pdfData.mileage_allowance}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Additional Puchased Miles (per year)</Text>
                    <Text>{pdfData.additional_miles}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Cost Per Mile</Text>
                    <Text>{pdfData.cost_per_mile.toDollarFormat()}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Total Additional Miles Charge</Text>
                    <Text>{pdfData.additional_miles_charge.toDollarFormat()}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Total Mileage Allowed</Text>
                    <Text>{pdfData.total_mileage_allowed}</Text>
                </View>

            </View>
        </View>
    )
}